import React from 'react';
import { Outlet } from 'react-router-dom';
import Topbar from '../agent/layout/Topbar';
import TimeoutModal from '../shared/TimeoutModal';
import ItineraryLimitModal from '../shared/ItineraryLimitModal';
import { NavModeProvider } from '../../hooks/useNavMode';
import { useUser } from '../../context/UserContext';

/**
 * AppChrome - Global layout wrapper that renders the persistent Topbar
 * This component ensures the Topbar is always present and never remounts
 * when navigating between Agent and Admin sections.
 * Topbar handles null user state internally.
 * Includes TimeoutModal for session management.
 * Wraps content in NavModeProvider to share navigation mode state.
 */
const AppChrome = () => {
  const { user } = useUser();

  return (
    <NavModeProvider>
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:top-2 focus:left-2 focus:z-50 focus:bg-white focus:px-4 focus:py-2 focus:rounded focus:shadow"
      >
        Skip to main content
      </a>
      <div className="flex flex-col h-screen overflow-hidden bg-gray-50">
        {/* Persistent Topbar - always rendered, never remounts */}
        <div className="flex-shrink-0">
          <Topbar />
        </div>
        {/* Content area - routes render here via Outlet; takes remaining height */}
        <div id="main-content" className="flex flex-1 min-h-0">
          <Outlet />
        </div>
      </div>
      {/* Session timeout warning */}
      <TimeoutModal userRole={user?.role ?? 'agent'} />
      {/* Itinerary limit upgrade prompt — fires on 402 from any API call */}
      <ItineraryLimitModal />
    </NavModeProvider>
  );
};

export default AppChrome;

